import { DataCache } from 'lib/DataCache';
import { PCCollection } from 'data/PCCache';
import { PilotsNavbar } from 'data/models/PilotsNavbar';

export class PilotsNavbarCache extends DataCache {
    PilotsNavbars = PCCollection(PilotsNavbar);
}



// WEBPACK FOOTER //
// ./apps/pilots/pilotsheader/cache.ts